import { render, staticRenderFns } from "./LocationsByDistributor.vue?vue&type=template&id=69768564&scoped=true&"
import script from "./LocationsByDistributor.vue?vue&type=script&lang=js&"
export * from "./LocationsByDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69768564",
  null
  
)

export default component.exports